<span><a v-for="link in field.values" :href="link[1]" target="_blank">{{link[0]}}</a></span>